import React from "react";
import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Home, Layout } from "react-feather";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";


const Sidebar = (props) => {
    const [selectHome, setSelectHome] = useState(false);
    const [selectDocumentClaim, setSelectDocumentClaim] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [sideBarOption, setSideBarOption] = useState('');
    //let isInitialLoad=true;
    const[isInitialLoad,setIsInitialLoad]= useState(true);
    const [trackChangeInSidebarOption,setTrackChangeInSidebarOption]= useState(true);
    const navigate = useNavigate();
    const handleClose = (option) => {
        setOpen(false);
        if (option === "Yes") {
            if(sideBarOption==="DocumentClaim")
            {
                navigate('/IntermediateFormScreen');
            }
            handleSidebarSelection(sideBarOption, 'Yes');
        }
        else if (option === "No") {
        }
    };
   
    useEffect(() => {
        if (props.defaultValue === "DocumentClaim") {
            handleSidebarSelection("DocumentClaim", "InitialLoad");
        } 
         else if (props.defaultValue === "Home") {
            handleSidebarSelection("Home");
        }
        else if (props.defaultValue === "IntermediateFormScreen") {
            handleSidebarSelection("DocumentClaim","InitialLoad");
        }
    }, []);

    useEffect(() => {
        if (selectHome === true) {
            navigate('/');
        }
        else if (selectDocumentClaim === true && isInitialLoad===false) {
            navigate('/IntermediateFormScreen');
        }
    }, [selectDocumentClaim, selectHome,trackChangeInSidebarOption])

    const handleSidebarSelection = (option, saveDataPopUpOption) => {
        // props.checkCallNotes();
        if(saveDataPopUpOption==='InitialLoad'){
            setIsInitialLoad(true);
        }
        else if(saveDataPopUpOption==='userInitiatedLoad'){
            setIsInitialLoad(false);
        }

        if(props.defaultValue==="DocumentClaim"){
        props.checkCallNotes();
        }
        if (props.defaultValue === "DocumentClaim" && (option === 'Home'||option === 'DocumentClaim') && (saveDataPopUpOption !== 'Yes')&& (saveDataPopUpOption !== 'InitialLoad')&&(props.checkCallNotes()!== false || props.areImagesChanged !== false || props.filesUploadedInSidebar.length !== 0 )) {
            setSideBarOption(option);
                setOpen(true);
            return;
        }
        else {
            if (option === "Home") {
                setSelectHome(true);
                setSelectDocumentClaim(false);
            } else if (option === "DocumentClaim") {
                setSelectHome(false);
                setSelectDocumentClaim(true);
                setTrackChangeInSidebarOption(!trackChangeInSidebarOption);
                if (saveDataPopUpOption === "ByPassIntermediate") {
                    return;
                }
            } 
        };
    }

    return (
        <>
            <div id="sidebar" className="active">
                <div className="sidebar-wrapper active">
                    <div className="sidebar-header">
                        <div className="fontLarge">Optum</div>
                        <div className="fontSmall">Audit Documentation Tool</div>
                    </div>

                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                If you leave this page changes may get lost. Do you want to stay or leave?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => handleClose("No")}>Stay</Button>
                            <Button  onClick={() => handleClose("Yes")} autoFocus>
                                Leave
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <div className="sidebar-menu">
                        <ul className="menu" id="names">
                            <NavLink
                                className={selectHome ? "navlinkactive " : "navlink"}
                            // to="/"
                            >
                                <li
                                    className={
                                        selectHome ? "sidebar-item active " : "sidebar-item"
                                    }
                                    onClick={() => {
                                        handleSidebarSelection("Home","userInitiatedLoad");
                                    }}
                                >
                                    <p className="sidebar-link" id="Home">
                                        <Home size={20} />

                                        <div className="marginLeftFive">Home</div>
                                    </p>
                                </li>
                            </NavLink>
                            <NavLink
                                className={selectDocumentClaim ? "navlinkactive " : "navlink"}
                            // to="/IntermediateFormScreen"
                            >
                                <li
                                    className={
                                        selectDocumentClaim
                                            ? "sidebar-item active "
                                            : "sidebar-item"
                                    }
                                    onClick={() => {
                                        handleSidebarSelection("DocumentClaim","userInitiatedLoad"); 
                                    }}
                                >
                                    <p className="sidebar-link" id="Approver">
                                        <Layout size={20} />
                                        <div className="marginLeftFive">
                                            <span>Document Claim</span>
                                        </div>
                                    </p>
                                </li>
                            </NavLink>
                        </ul>
                    </div>
                    <button className="sidebar-toggler btn x">
                        <i data-feather="x"></i>
                    </button>
                </div>
            </div>
        </>
    );
};

export default Sidebar;
